import React from "react";
//import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
//import store from "./store";
import history from "./history";
import Layouts from "./layouts";
import { THEME_CONFIG } from "./configs/AppConfig";
//import mockServer from "./mock";
import "./lang";
import {
  MutationCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { ConfigProvider, notification, theme } from "antd";
import { ModalProvider } from "components/util-components/ModalService";
import { themeStore } from "stores/themeStore.store";

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};
const mutationCache = new MutationCache({
  onError: (error, _variables, _ctx, mutation) => {
    if (mutation.options.onError) return;
    notification.error({
      message: error.message,
    });
  },
});
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
  mutationCache,
});
function App() {
  const { currentTheme } = themeStore();
  return (
    <div className="App">
      {/* <Provider > */}
      <BrowserRouter history={history}>
        <QueryClientProvider client={queryClient}>
          <ThemeSwitcherProvider
            themeMap={themes}
            defaultTheme={currentTheme || THEME_CONFIG.currentTheme}
            insertionPoint="styles-insertion-point"
          >
            <ConfigProvider
              theme={{
                algorithm:
                  currentTheme === "dark"
                    ? theme.darkAlgorithm
                    : theme.defaultAlgorithm,
                token: {
                  colorPrimary: "#3E3657",
                  fontFamily: "Inter, sans-serif",
                },
                components: {
                  Table: {
                    headerBg: "#F5F7FA",
                    headerColor: "#5F6D7E",
                    rowSelectedHoverBg: "#F5F7FA",
                    cellPaddingBlock: 20,
                    borderColor: "#E1E4EA",
                  },
                  // Pagination: {
                  //   itemActiveBg: "#F5F7FA",
                  // },
                },
              }}
            >
              <ModalProvider />
              <Layouts />
            </ConfigProvider>
          </ThemeSwitcherProvider>
        </QueryClientProvider>
      </BrowserRouter>
      {/* </Provider> */}
    </div>
  );
}

export default App;
